"use client";

import apiService from "../pages/api/apiClient";
import { toast } from "react-toastify";
import { useState } from "react";
import { useSelector } from "react-redux";

export default function CheckoutButton({
  Sty,
  proccess,
  donate_now,
  id,
  amount,
  type,
  email,
  issubscription,
  onValidate
}) {
  const [loadingState, setLoadingState] = useState(false);
  const customer_email = useSelector((state) => state.auth.email);

  const handleCheckout = async () => {
    // ✅ Trigger validation from parent
    const isValid = onValidate?.();
    if (!isValid) return;

    const body = {
      amount,
      type,
      child_id: id,
      email: email || customer_email,
      is_subscription: issubscription
    };

    setLoadingState(true);
    try {
      const res = await apiService.post("/create-checkout-session", body);
      if (res?.url) {
        window.location.href = res.url;
      } else {
        setLoadingState(false);
        toast.error("Unable to create checkout session.");
      }
    } catch (error) {
      setLoadingState(false);
      toast.error("Payment initialization failed.");
    }
  };

  return (
    <button
      onClick={handleCheckout}
      className={`${Sty} btn-spacing`}
      disabled={loadingState}
    >
      {loadingState ? (
        <>
          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          {proccess}...
        </>
      ) : (
        <>
          {donate_now} <span className="ms-2">→</span>
        </>
      )}
    </button>
  );
}

